import type { MapFiltersValue } from './MapFiltersSheet';

/** How many of the sheet's sections hold a filter; the bar's badge shows it. */
export const countAppliedFilters = (value: MapFiltersValue): number =>
  [
    !Object.values(value.homeTypes).every(Boolean),
    Object.values(value.features).some(Boolean),
    value.size.min != null || value.size.max != null,
    value.lot.min != null || value.lot.max != null,
    Object.values(value.status).some(Boolean),
  ].filter(Boolean).length;
